import * as React from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from 'react-router-dom';
import * as Auth from '../libs/auth';
import { LOGIN_PAGE_ROUTE } from '../pages/login';

type Props = RouteProps & {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
};

export default function ProtectedRoute({
  component: Component,
  ...rest
}: Props) {
  const renderFn = (props: RouteComponentProps) => {
    if (!Auth.isLoggedIn()) {
      return (
        <Redirect
          to={{
            pathname: LOGIN_PAGE_ROUTE,
            state: {
              from: `${props.location.pathname}${props.location.search}`,
            },
          }}
        />
      );
    }
    return <Component {...props} />;
  };

  return <Route {...rest} render={renderFn} />;
}
